<template>
  <div class="customer-attr-choose">
    <el-form :label-position="labelPosition" :rules="cusAttrFormRules" :model="formLabelAlign">
      <el-form-item label="步骤名称" :label-width="addLabelWidth">
        <el-input v-model="formLabelAlign.name" disabled style="width: 370px;"></el-input>
      </el-form-item>
      <el-form-item label="属性名称" prop="attrId" :label-width="addLabelWidth">
        <el-select @change="update" v-model="formLabelAlign.attrId" placeholder="请选择">
          <el-option
            v-for="item in customerOptions"
            :key="item.identity"
            :label="item.name"
            :value="item.identity">
          </el-option>
        </el-select>
      </el-form-item>
      <!--判断是input select或者什么-->
      <el-form-item prop="attrVal" label="属性设置" :label-width="addLabelWidth">
        <!--input-->
        <el-input v-if="contentType === 'input'" @change="updates" v-model="formLabelAlign.attrVal" style="width: 370px;"></el-input>
        <!--select-->
        <el-select @change="updates" class="ifSelect" v-if="contentType === 'select'" v-model="formLabelAlign.attrVal" placeholder="请选择查询内容">
          <el-option
            v-for="i in nowOption"
            :key="i"
            :label="i"
            :value="i">
          </el-option>
        </el-select>
        <!--datePicker-->
        <el-date-picker
          v-if="contentType === 'datePicker'"
          v-model="formLabelAlign.attrVal"
          type="date"
          class="dateTimePicker"
          value-format="yyyy-MM-dd"
          @change="updates"
          placeholder="选择日期">
        </el-date-picker>
        <!--dateTimePicker-->
        <el-date-picker
          v-if="contentType === 'dateTimePicker'"
          v-model="formLabelAlign.attrVal"
          type="datetime"
          value-format="yyyy-MM-dd"
          class="dateTimePicker"
          @change="updates"
          placeholder="选择时间和日期">
        </el-date-picker>
        <!--addressPicker-->
        <el-cascader
          v-if="contentType === 'addressPicker'"
          class="area"
          size="large"
          :options="addressOptions"
          v-model="formLabelAlign.attrVal"
          @change="updates">
        </el-cascader>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getCustomerAttributeList } from '@/api/customer.js'
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      addLabelWidth: '90px',
      cusAttrFormRules: {
        attrId: [
          { required: true, message: '属性名称不能为空', trigger: 'change' }
        ],
        attrVal: [
          { required: true, message: '属性值不能为空', trigger: 'change' }
        ]
      },
      customerOptions: [],
      nowOption: [],
      contentType: 'input',
      labelPosition: 'right',
      addressOptions: regionDataPlus,
      formLabelAlign: this.contents,
      choose: {}
    }
  },
  computed: {
  },
  methods: {
    // 传值到父组件
    update() {
      this.formLabelAlign.attrVal = null
      for (let item of this.customerOptions) {
        if (this.formLabelAlign.attrId === item.identity) {
          this.contentType = item.type
          this.nowOption = item.option
        }
      }
      // 传值到父组件
      this.choose.nodeType = 'customerAttrNode'
      this.choose.attrId = this.formLabelAlign.attrId
    },
    updates() {
      // 传值到父组件
      this.choose.nodeType = 'customerAttrNode'
      this.choose.name = '客户属性'
      this.choose.attrId = this.formLabelAlign.attrId
      this.choose.attrVal = this.formLabelAlign.attrVal
      this.choose.id = this.formLabelAlign.id
      this.$emit('change', this.choose)
    },
    loadCustomerAttribute() {
      getCustomerAttributeList().then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data
          let remainData = []
          // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
          for (let i in data) {
            if (data[i].type === 'radio') {
              data[i].type = 'select'
            }
            if (data[i].type === 'checkBox') {
              continue
            }
            if (data[i].identity === 'district' || data[i].identity === 'city' || data[i].identity === 'province' || data[i].identity === 'country_id') {
              continue
            }
            remainData.push(data[i])
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity + '@' + remainData[i].type
            remainData[i].label = remainData[i].name
          }
          remainData.push({
            name: '省市区',
            identity: 'systemPcd',
            type: 'addressPicker',
            option: []
          })
          this.customerOptions = remainData
        }
      })
    }
  },
  watch: {
    contents: function (val) {
      this.formLabelAlign = val
      console.log('contents1', val)
    }
  },
  created() {
    this.loadCustomerAttribute()
    console.log('contents2', this.contents)
  }
}
</script>

<style scoped>

</style>
